module.exports = __webpack_public_path__ + "fonts/adcde98.woff";